export enum TemplateType {
  GENERAL = 'GENERAL',
  DRAINAGE = 'DRAINAGE',
  GEOMETRIC = 'GEOMETRIC', // Geometric has been deprecated
  GEOTECHNICS = 'GEOTECHNICS',
  LIGHTING = 'LIGHTING',
  NON_PRESCRIBED_TRAFFIC_SIGNS_AND_ROAD_STUDS = 'NON_PRESCRIBED_TRAFFIC_SIGNS_AND_ROAD_STUDS',
  PAVEMENT = 'PAVEMENT',
  ROAD_LAYOUT = 'ROAD_LAYOUT',
  SIGNALS_AND_VMS = 'SIGNALS_AND_VMS',
  STRUCTURES = 'STRUCTURES',
  SUSTAINABILITY_AND_ENVIRONMENT = 'SUSTAINABILITY_AND_ENVIRONMENT',
  TECHNOLOGY = 'TECHNOLOGY',
  VEHICLE_RESTRAINT_SYSTEMS = 'VEHICLE_RESTRAINT_SYSTEMS'
}
